import lodash from 'lodash';

import {EASINGS} from '../../ecs/easingHelper';
import easeInRightGif from '../../../assets/images/transitions/easeInRight.gif';

/**
 * The name that signals this preset.
 * @const {string}
 */
export const PRESET_EASE_IN_RIGHT = 'easeInRight';

/**
 * The preset details.
 *
 * @type {{
 *   name: string,
 *   humanName: string,
 *   flow: string,
 *   details: Object.<string, {
 *     easing: string,
 *     parse: boolean,
 *     values: *|Array.<*>,
 *     time: {start: (string|number), end: (string|number)}
 *   }>,
 *   template: {}
 * }}
 */
export const easeInRightPresetDetails = {
  // The name of the preset.
  name: PRESET_EASE_IN_RIGHT,

  // A human friendly name for the preset.
  humanName: 'Ease In & Rotate From Right',

  // A preview of the transition.
  gif: easeInRightGif,

  // The element names that this preset can be used for or true for all elements.
  elements: true,

  // The preset direction: in, out, middle. This is used in the UI logic.
  flow: 'in',

  // Each property that will change during the transition.
  details: {
    'position.x': {
      time: {
        start: 'start.0',
        end: 'start.1000'
      },
      easing: EASINGS.easeOutPower3,
      values: [
        'off.right',
        'position.right'
      ],
      immediateRender: true
    },
    'transform.rotate': {
      time: {
        start: 'start.0',
        end: 'start.1000'
      },
      easing: EASINGS.easeOutPower3,
      values: [
        '90',
        '0'
      ],
      immediateRender: true
    },
  },

  // How this preset can be used in the source (including optional parameters).
  // This will be turned into a JSON string, so no functions can be used.
  template: {
    preset: PRESET_EASE_IN_RIGHT,
    options: {},
  },
};

easeInRightPresetDetails.template.options = lodash.cloneDeep(easeInRightPresetDetails.details);

// This defines the key in the presets object.
export const presetName = PRESET_EASE_IN_RIGHT;

// This defines the value of the presets object.
export default easeInRightPresetDetails;
